export const FETCH_PAYROLL_ALLOWANCE_REQUEST = 'FETCH_PAYROLL_ALLOWANCE_REQUEST';
export const FETCH_PAYROLL_ALLOWANCE_SUCCESS = 'FETCH_PAYROLL_ALLOWANCE_SUCCESS';
export const FETCH_PAYROLL_ALLOWANCE_FAILURE = 'FETCH_PAYROLL_ALLOWANCE_FAILURE';

export const SAVE_PAYROLL_ALLOWANCE_REQUEST = 'SAVE_PAYROLL_ALLOWANCE_REQUEST';
export const SAVE_PAYROLL_ALLOWANCE_SUCCESS = 'SAVE_PAYROLL_ALLOWANCE_SUCCESS';
export const SAVE_PAYROLL_ALLOWANCE_FAILURE = 'SAVE_PAYROLL_ALLOWANCE_FAILURE';

export const REMOVE_PAYROLL_ALLOWANCE_REQUEST = 'REMOVE_PAYROLL_ALLOWANCE_REQUEST';
export const REMOVE_PAYROLL_ALLOWANCE_SUCCESS = 'REMOVE_PAYROLL_ALLOWANCE_SUCCESS';
export const REMOVE_PAYROLL_ALLOWANCE_FAILURE = 'REMOVE_PAYROLL_ALLOWANCE_FAILURE';

export const FETCH_PAYROLL_ALLOWANCES_DROPDOWN_REQUEST = 'FETCH_PAYROLL_ALLOWANCES_DROPDOWN_REQUEST';
export const FETCH_PAYROLL_ALLOWANCES_DROPDOWN_SUCCESS = 'FETCH_PAYROLL_ALLOWANCES_DROPDOWN_SUCCESS';
export const FETCH_PAYROLL_ALLOWANCES_DROPDOWN_FAILURE = 'FETCH_PAYROLL_ALLOWANCES_DROPDOWN_FAILURE';

export const FETCH_PAYROLL_ALLOWANCES_TEMPLATE_REQUEST = 'FETCH_PAYROLL_ALLOWANCES_TEMPLATE_REQUEST';
export const FETCH_PAYROLL_ALLOWANCES_TEMPLATE_SUCCESS = 'FETCH_PAYROLL_ALLOWANCES_TEMPLATE_SUCCESS';
export const FETCH_PAYROLL_ALLOWANCES_TEMPLATE_FAILURE = 'FETCH_PAYROLL_ALLOWANCES_TEMPLATE_FAILURE';

export const PAYROLL_DEDUCTION_ALLOWANCE_IMPORT = 'PAYROLL_DEDUCTION_ALLOWANCE_IMPORT';
export const PAYROLL_DEDUCTION_ALLOWANCE_IMPORT_SUCCESS = 'PAYROLL_DEDUCTION_ALLOWANCE_IMPORT_SUCCESS';
export const PAYROLL_DEDUCTION_ALLOWANCE_IMPORT_FAILURE = 'PAYROLL_DEDUCTION_ALLOWANCE_IMPORT_FAILURE';

export const RESET_SAVE_STATUS = "RESET_SAVE_STATUS";
